module.exports = __webpack_public_path__ + "img/bch.161df605.svg";